import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { NeutralColors } from '@fluentui/theme';
import { mergeStyleSets } from '@fluentui/react';
const appReviewCommentStyles = mergeStyleSets({
    commentsContainer: {
        marginBottom: '20px'
    },
    paginationContainer: {
        marginTop: '10px'
    },
    emptyMessage: {
        margin: '15px 0',
        color: NeutralColors.gray130
    },
    loader: {
        margin: '25px 0'
    }
});
export function AppReviewItemCommentEmptyMessage(params, context) {
    return /*#__PURE__*/ _jsx("div", {
        className: appReviewCommentStyles.emptyMessage,
        children: context.loc('ReviewItem_CommentSection_Empty_Message', 'No comments yet. Be the first one to comment.')
    });
}
AppReviewItemCommentEmptyMessage.contextTypes = {
    loc: PropTypes.func
};
